export enum AccountStatusEnum {
  NoAccountOnEmail = "NoAccountOnEmail",
  NoKnownIssues = "NoKnownIssues",
  InvitationExists = "InvitationExists",
  AccountRequestExists = "AccountRequestExists",
  UserHasNotFinishedRegistration = "UserHasNotFinishedRegistration",
  NoAccountChosen = "Ingen konto valgt",
  MissingPassword = "MissingPassword",
}